<div class="mt-6">
  <div [formGroup]="formOrigin" class="mt-4 container mx-auto">
    <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
      <div class="w-full px-2">
        <div class="box-form">
          <h4 class="bg-gray">Origem</h4>
          <div class="input-box flex flex-col items-center w-full">
            <div class="flex justify-between items-center -mx-2 w-full">
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>CEP</mat-label>
                <input
                  matInput
                  formControlName="originPostalCode"
                  (input)="getAddressByPostalCode('origin')"
                  (blur)="getAddressByPostalCode('origin')"
                />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-6/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Logradouro</mat-label>
                <input matInput formControlName="originStreet" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-1/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Número</mat-label>
                <input matInput formControlName="originNumber" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="originNeighborhood" />
              </mat-form-field>
            </div>
            <div class="flex justify-between items-center mt-4 -mx-2 w-full">
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="originComplement" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Latitude</mat-label>
                <input matInput formControlName="originLatitude" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Longitude</mat-label>
                <input matInput formControlName="originLongitude" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Cidade</mat-label>
                <input matInput formControlName="originCity" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Estado</mat-label>
                <input matInput formControlName="originState" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [formGroup]="formDestination" class="mt-4 container mx-auto">
    <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
      <div class="w-full px-2">
        <div class="box-form">
          <h4 class="bg-gray">Destino</h4>
          <div class="input-box flex flex-col items-center w-full">
            <div class="flex justify-between items-center -mx-2 w-full">
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>CEP</mat-label>
                <input
                  matInput
                  formControlName="destinationPostalCode"
                  (input)="getAddressByPostalCode('destination')"
                  (blur)="getAddressByPostalCode('destination')"
                />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-6/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Logradouro</mat-label>
                <input matInput formControlName="destinationStreet" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-1/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Número</mat-label>
                <input matInput formControlName="destinationNumber" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="destinationNeighborhood" />
              </mat-form-field>
            </div>
            <div class="flex justify-between items-center mt-4 -mx-2 w-full">
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="destinationComplement" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Latitude</mat-label>
                <input matInput formControlName="destinationLatitude" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Longitude</mat-label>
                <input matInput formControlName="destinationLongitude" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Cidade</mat-label>
                <input matInput formControlName="destinationCity" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Estado</mat-label>
                <input matInput formControlName="destinationState" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [formGroup]="form" class="mt-4 container mx-auto">
    <div class="flex justify-between items-center mt-3 -mx-2">
      <mat-form-field appearance="outline" class="input-tg w-4/12 px-2">
        <mat-label>Origem</mat-label>

        <input
          matInput
          type="text"
          formControlName="origin"
          [matAutocomplete]="autoOrigin"
        />

        <mat-autocomplete
          #autoOrigin="matAutocomplete"
          [displayWith]="displayLocation"
          autoActiveFirstOption
          (optionSelected)="onOriginSelected($event)"
        >
          <mat-option *ngFor="let opt of filteredOrigins | async" [value]="opt">
            {{ opt.descricao }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="input-tg w-4/12 px-2" appearance="outline">
        <mat-label>Destino</mat-label>
        <input
          matInput
          type="text"
          formControlName="destination"
          [matAutocomplete]="autoDestination"
        />

        <mat-autocomplete
          #autoDestination="matAutocomplete"
          [displayWith]="displayLocation"
          autoActiveFirstOption
          (optionSelected)="onDestinationSelected($event)"
        >
          <mat-option
            *ngFor="let opt of filteredDestinations | async"
            [value]="opt"
          >
            {{ opt.descricao }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
        <mat-label>Perimetro Urbano</mat-label>
        <mat-select formControlName="urbanPerimeter">
          @for (type of listPerimeter; track type) {
            <mat-option [value]="type.value">{{ type.description }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <!--      <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">-->
      <!--        <mat-label>Standard</mat-label>-->
      <!--        <mat-select formControlName="standard" >-->
      <!--          @for (type of listStandard; track type) {-->
      <!--          <mat-option [value]="type.value">{{ type.description }}</mat-option>-->
      <!--          }-->
      <!--        </mat-select>-->
      <!--      </mat-form-field>-->
    </div>
    <div class="flex justify-between items-center mt-3 -mx-2">
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Tipo Serviço</mat-label>
        <mat-select
          formControlName="serviceType"
          (selectionChange)="onSelectionChangeServiceSpecification($event)"
        >
          @for (type of listTypeService; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Serviço</mat-label>
        <mat-select
          formControlName="specificationService"
          (selectionChange)="onSelectionChangeService($event)"
        >
          @if (listServiceSpecification.length == 0) {
            <mat-option disabled>Nenhum registro.</mat-option>
          } @else {
            @for (type of listServiceSpecification; track type) {
              <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Tipo veículo</mat-label>
        <mat-select formControlName="vehicleType">
          @for (type of listTypeVehicle; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
        <mat-label>Tipo motorista</mat-label>
        <mat-select formControlName="driverType">
          @for (type of listTypeDriver; track type) {
            <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
